// Vendored from gs-ui-templates/src/components/Image/index.tsx (a thin <img> wrapper
// that also accepts a `loader` function prop), stripped of its TS prop types.
const Image = ({ loader, src, ...props }) => {
  const imageSrc = loader ? (loader() || src) : src;

  return (
    <img
      src = {imageSrc}
      {...props}
    />
  );
};

export default Image;
